module.exports = __webpack_public_path__ + "img/market.94177dff.svg";